module.exports = __webpack_public_path__ + "img/img4-3.778d9261.png";